export function date_on_calendar_click(form) {
	var that = form;
	$(form).find('table td.day').click(function(event){
		//remove listeners to prevent multiple calls
		$(form).find('table td.day').unbind('click');
		//proceed
		$('#to_submit_date').val($(this).data('day'));
		$(that).submit();
	});
};